import { observable } from "mobx";
import { searchArtworks as apiSearchArtworks, authenticate, getRandomArtworks as apiGetRandomArtworks } from "./api";

const ArtModel = observable({
  searchResults: null,
  currentQuery: "",
  token: localStorage.getItem("xappToken") || null,
  loading: false,
  favorites: { paintings: [], artists: [] },
  currentPage: 0,
  hasNextPage: false,
  totalCount: 0,
  isLoggedIn: false,
  randomArtworks: [],

  async initialize() {
    try {
      const storedToken = localStorage.getItem("xappToken");
      if (storedToken) {
        const response = await fetch("https://api.artsy.net/api/artworks?size=1", {
          headers: { "X-XAPP-Token": storedToken },
        });
        if (response.ok) {
          this.setToken(storedToken);
          return;
        }
      }
      const token = await authenticate();
      this.setToken(token);
    } catch (error) {
      console.error("Failed to initialize or refresh token:", error);
      localStorage.removeItem("xappToken");
    }
  },
  
  

  setToken(token) {
    this.token = token;
    localStorage.setItem("xappToken", token);
  },


  

  setQuery(query) {
    this.currentQuery = typeof query === "string" ? query : String(query);
  },
  

  getQuery() {
    return this.currentQuery;
  },

  async searchArtworks() {
    if (!this.currentQuery.trim()) return;

    this.resetSearch(); 

    try {
      const results = await apiSearchArtworks(this.currentQuery, this.token);
      this.handleSearchResults(results);
    } catch (error) {
      console.error("Error searching artworks:", error);
    } finally {
      this.setLoading(false);
    }
  },

  async loadNextPage() {
    if (!this.hasNextPage || this.loading) return;

    this.setLoading(true);
    this.currentPage += 1;

    try {
      const offset = this.currentPage * 10;
      const results = await apiSearchArtworks(this.currentQuery, this.token, offset);
      this.appendSearchResults(results);
    } catch (error) {
      console.error("Error loading next page:", error);
    } finally {
      this.setLoading(false);
    }
  },

  resetSearch() {
    this.searchResults = null;
    this.currentPage = 0;
    this.hasNextPage = false;
    this.setLoading(true);
  },

  addToFavorites(item, type) {
    if (type === "painting" && !this.favorites.paintings.includes(item)) {
      this.favorites = {
        ...this.favorites,
        paintings: [...this.favorites.paintings, item]
      };
    }
    if (type === "artist" && !this.favorites.artists.includes(item)) {
      this.favorites = {
        ...this.favorites,
        artists: [...this.favorites.artists, item]
      };
    }
  },

  removeFavorite(item, type) {
    if (type === "painting") {
      this.favorites = {
        ...this.favorites,
        paintings: this.favorites.paintings.filter(fav => fav !== item)
      };
    }
    else if (type === "artist") {
      this.favorites = {
        ...this.favorites,
        artists: this.favorites.artists.filter(fav => fav !== item)
      };
    }
  },

  getFavorites(){
    return this.favorites;
  },

  async getRandomPaintings(size){
    const offset = Math.floor(Math.random() * 100);
    try{
        const results = await apiGetRandomArtworks(this.token, size, offset);
        return results;
    }catch(err){
      console.error("Failed to retrieve paintings", err);
      return [];
    }
  },
  

  isFavorite(item, type) {
    if (type === "painting") {
        return this.favorites.paintings.some(fav => fav.title === item.title && fav.artistName === item.artistName);
    }
    if (type === "artist") {
        return this.favorites.artists.some(fav => fav.artistName === item.artistName);
    }
    return false;
},

  appendSearchResults(results) {
    this.searchResults = [...this.searchResults, ...results.artworks];
    this.hasNextPage = results.hasNextPage;
  },

  handleSearchResults(results) {
    this.searchResults = results.artworks;
    this.hasNextPage = results.hasNextPage;
    this.totalCount = results.totalCount;
  },

  setLoading(loading) {
    this.loading = loading;
  },

  setIsLoggedIn(user) {
    this.isLoggedIn = user;
  },

  async loadRandomArtworks(number) {
    try {
      const results = await this.getRandomPaintings(number);
      this.randomArtworks = results;
    } catch (error) {
      console.error("Failed to load random artworks:", error);
    }
  },
});



export default ArtModel;